/* Copyright IBM Corp. 2018 */

export type Generator<T> = () => T | null | undefined;

const _arrayGenerator = <T> (): T[] => ([]);
const _objectGenerator = (): any => ({});

export {
    _arrayGenerator as arrayGenerator,
    _objectGenerator as objectGenerator
};
